// Homepage only: flips the transparent header to solid once the page is scrolled.
(function () {
  const SOLID_AFTER_PX = 20;

  const update = () => {
    document.body.classList.toggle('header-is-solid', window.scrollY > SOLID_AFTER_PX);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
})();
